import { defineStore } from 'pinia'
import { request } from '../../api'

export const useManufacturingStore = defineStore('manufacturing', {
  state: () => ({
    factoriesFilters: null,
    factoriesLetters: null,
    factoriesList: null,
    factory: null,
  }),
  getters: {},
  actions: {
    async getFactories (params) {
      try {
        const { data } = await request.get('/data/factories', {
          params: params,
        })
        if (data) {
          this.factoriesList = data.list
          this.factoriesLetters = data.letters
          this.factoriesFilters = data.filters
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    async getFactory (id) {
      try {
        const { data } = await request.get(`data/factories/${id}`)
        if (data) {
          this.factory = data
        }
      } catch (e) {
        console.error(e.message)
      }
    },
  },
})
